import SmsView from "../sms/smsView";
import SmsEdit from "../sms/smsEdit";
import React from "react";
class SmsToggle extends React.Component {
  constructor(props) {
    super(props);
    this.state = { toggleEditMode: false, success: false, smsData: "" };
    this.toggleMode = this.toggleMode.bind(this);
    this.showSuccess = this.showSuccess.bind(this);
    this.setSMSData = this.setSMSData.bind(this);
  }
  toggleMode(val) {
    this.setState({ toggleEditMode: val });
  }
  showSuccess(val) {
    this.setState({ success: val });
    setTimeout(() => {
      this.setState({ success: false });
    }, 10000);
  }
  setSMSData(val) {
    this.setState({ smsData: val });
  }
  render() {
    const message = this.props.message;
    const accessSpecifier = this.props.accessSpecifier;
    return (
      <>
        {this.state.toggleEditMode ? (
          <SmsEdit
            message={message}
            toggleMode={this.toggleMode}
            success={this.showSuccess}
            smsData={this.state.smsData}
          />
        ) : (
          <SmsView
            message={message}
            toggleMode={this.toggleMode}
            isSuccess={this.state.success}
            accessSpecifier={accessSpecifier}
            setSMSData={this.setSMSData}
          />
        )}
      </>
    );
  }
}

export default SmsToggle;
